import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

import { AccessDeniedPage } from "../../../pages/auth-info/containers/access-denied-page";
import { AccountNotConnectedPage } from "../../../pages/auth-info/containers/account-not-connected-page";
import { RemoteFailurePage } from "../../../pages/auth-info/containers/remote-failure-page";
import { SessionCheckFailedPage } from "../../../pages/auth-info/containers/session-check-failed-page";
import { SpinnerCenter } from "../../../shared/components/spinner-center/spinner-center";
import { useAuthGate } from "../../hooks/use-auth-gate";
import { useCanViewGeneral } from "../../hooks/use-general-permissions";
import { getUserId } from "../../store/auth.selector";

export const ProtectedRoute = () => {
  const {
    isAuthenticated,
    isLoadingUserDto,
    sessionCheckFailure,
    isSignInLooped,
    retry,
  } = useAuthGate();
  const canViewGeneral = useCanViewGeneral();
  const userId = useSelector(getUserId);

  if (sessionCheckFailure === "forbidden") {
    return <AccessDeniedPage />;
  }
  if (sessionCheckFailure === "error") {
    return <SessionCheckFailedPage onRetry={retry} />;
  }
  if (isSignInLooped) {
    return <RemoteFailurePage />;
  }
  if (isLoadingUserDto) {
    return <SpinnerCenter msg="Загружаются пользовательские данные..." />;
  }
  if (!isAuthenticated) {
    return <SpinnerCenter msg="Ожидание авторизации..." />;
  }
  if (!userId) {
    return <AccountNotConnectedPage />;
  }
  if (!canViewGeneral) {
    return <AccessDeniedPage />;
  }

  return <Outlet />;
};
